import { useEffect, useState } from "react";
import { getPinnedObjectLoading, subscribeToPinnedObjectLoading } from "../../../utils/pinned-object-progress";

export function usePinnedObjectLoading() {
  const [progress, setProgress] = useState(getPinnedObjectLoading);

  useEffect(() => subscribeToPinnedObjectLoading(setProgress), []);

  return progress;
}
